
import React from 'react';
import Language from '../language/language'
import { message, Button } from 'antd'
import { inject, observer } from 'mobx-react';
import { $const } from '../../helper'
import CountDown from '../common/countDown'
import moment from 'moment'

import './stylesheets/gameJudgeForm.scss'

@inject('gameStore', 'teamStore', 'commonStore', 'languageStore', 'authStore')
@observer
export default class GameJudgeForm extends React.Component {
  state = {
    isCountDown: false,
    isDisable: false,
    isLoading: false,
    registrationStageStatusId: undefined,
    forMultiPeople: false,
    isCaptain: false,
  }
  componentDidMount () {
    const registrationStageStatusId = this.props.registrationStageStatusId
    if (registrationStageStatusId) {
      this.setState({
        registrationStageStatusId: registrationStageStatusId
      })
        if (this.props.teamStore.quiz && this.props.teamStore.quiz[registrationStageStatusId] && this.props.teamStore.quiz[registrationStageStatusId].history) {
          // 答题的历史数据
          let history = this.props.teamStore.quiz[registrationStageStatusId].history
          const config = this.props.teamStore.quiz[registrationStageStatusId].config
          // 多人测评
          if (config && config.forMultiPeople) {
            this.setState({
              forMultiPeople: true
            })
            const pendingList = history.filter(item => item.status === 'pending')
            const now = moment().valueOf()
            if((history[0] && this.props.authStore.user.id === history[0].creatorId)) {
              this.setState({
                isCaptain: true
              })
            }
           if (pendingList.length && now > moment(pendingList[0].beginAt).valueOf() && now < moment(pendingList[0].endAt).valueOf()) {
              if (pendingList[0].haveJudgedQuiz) {
                // 提交过测评
                return this.setState({
                  isDisable: true
                })
              } else {
                // 未提交过测评
                return this.setState({
                  isLimit: false,
                  isCountDown: false,
                  isDisable: false
                })
              }
            } else {
              if (history.length < config.limitTimes) {
                if ( history.length === 0 || moment(history[0].endAt).valueOf() + config.interval * 1000 < now) {
                  // 当前时间大于 （间隔时间 + 最后一次测评时间） 或者 队长第一次创建
                  if (!history[0]) {
                    // 兼容
                    // 当数据不存在，是队长
                    if (this.props.isCaptain) {
                       // 当前用户为小队队长 允许点击【发起测评】按钮
                      return this.setState({
                        isLimit: false,
                        isCountDown: false,
                        isDisable: false,
                        isCaptain: true
                      })
                    } else {
                      // 不允许点击【发起测评】按钮 仅队长可发起测评场次，可以以此提示普通成员
                      return this.setState({
                        isDisable: true
                      })
                    }
                  }
                  if (this.props.authStore.user.id === history[0].creatorId) {
                    // 当数据大于1条，并且当前用户为小队队长 允许点击【发起测评】按钮
                    return this.setState({
                      isLimit: false,
                      isCountDown: false,
                      isDisable: false,
                      isCaptain: true
                    })
                  } else {
                    // 不允许点击【发起测评】按钮 仅队长可发起测评场次，可以以此提示普通成员
                    return this.setState({
                      isDisable: true
                    })
                  }
                } else {
                  // 不允许点击【发起测评】按钮 因为距最近结束的场次的时间间隔还不满足配置的时间间隔
                  return this.setState({
                    isCountDown: true,
                    target: moment(history[0].endAt).valueOf() + config.interval*1000
                  })
                }
              } else {
                // 不允许点击【发起测评】按钮 因为存在的测评场次已经达到配置的数量上限
                return this.setState({
                  isLimit: true
                })
              }
            }
          }
          // 单人测评
          let sum = 0
          history.forEach((item) => {
            if (item.status === $const.QUIZ_STATUS.JUDGED || item.status === $const.QUIZ_STATUS.STARTED) {
              sum++
            }
          })
          if (config) {
            if (sum >= config.limitTimes ) {
              this.setState({
                isLimit: true
              })
            }
            // 检验时间
            if (history[0] && history[0].status === $const.QUIZ_STATUS.JUDGED) {
              // 判断时间
              if (moment(history[0].createdAt).valueOf() + config.interval*1000 > moment().valueOf() ) {
                this.setState({
                  isCountDown: true,
                  target: moment(history[0].createdAt).valueOf() + config.interval*1000
                })
              }
            }
          }
        }
    }
  }
  getNewJudgeLink = () => {
    if (this.state.forMultiPeople && !this.state.isCaptain) {
      // 多人测评，倒计时走完之后，队员的按钮还是要置灰
      return this.setState({
        isCountDown: false,
        isDisable: true
      })
    }
    this.setState({
      isCountDown: false
    })
  }
  getContent = () => {
    if (this.state.isLimit) {
      return <Language resource="SUBMIT_LIMIT" ></Language>
    }
    if (this.state.isCountDown) {
      return <CountDown target={this.state.target} onEnd={this.getNewJudgeLink} ></CountDown>
    }
    return <Language resource="START_EVALUATION" ></Language>
  }
  createQuiz = () => {
    this.setState({
      isLoading: true
    })
    this.props.teamStore.createQuiz(this.state.registrationStageStatusId, this.props.languageStore.lang).then(() => {
      if(this.props.teamStore.createQuizList && this.props.teamStore.createQuizList[this.state.registrationStageStatusId] && this.props.teamStore.createQuizList[this.state.registrationStageStatusId].instantUrl) {
        window.location.href = `${this.props.teamStore.createQuizList[this.state.registrationStageStatusId].instantUrl}?locale=${this.props.languageStore.lang}`
      }
    }).catch(()=>{
      const lang = this.props.languageStore.lang
      message.warning(this.props.languageStore.getResource(lang, 'MUTI_ERROR'))
    }).finally(() => {
      this.setState({
        isLoading: false
      })
    })
  }
  render () {
    if (!this.state.registrationStageStatusId) {
      return null
    }
    return (
      <div className="game-form-judge">
        <Button onClick={this.createQuiz} disabled={this.state.isCountDown || this.state.isLimit || this.state.isDisable} loading={this.state.isLoading}>
          {this.getContent()}
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/formList/gameJudgeForm.js